import { i18nFiscal } from './i18n-fiscal';
import { i18nRelogio } from './i18n-relogio';

/** Textos do módulo Registro de ponto (lote 1). Sem travessão e sem emoji; o es usa "tú". */
const pt = {
  nome: 'Registro de ponto',
  abas: { marcar: 'Marcar ponto', marcacoes: 'Marcações', espelho: 'Espelho', ajustes: 'Ajustes', banco: 'Banco de horas', fechamentos: 'Fechamentos', fiscal: 'Arquivos fiscais', configuracao: 'Configuração' },
  indicadores: { ponto_ausentes_sem_justificativa: 'Ausentes sem justificativa hoje' },
  acoes: {
    marcarEntrada: 'Marcar entrada',
    marcarSaida: 'Marcar saída',
    escolherFoto: 'Escolher foto',
    trocarFoto: 'Trocar foto',
    novoAjuste: 'Novo ajuste',
    pedirDesconsiderar: 'Pedir para desconsiderar',
    aprovar: 'Aprovar',
    recusar: 'Recusar',
    cancelarAjuste: 'Cancelar ajuste',
    fecharMes: 'Fechar mês',
    reabrir: 'Reabrir',
    novaPolitica: 'Nova política',
    editarConfiguracao: 'Editar configuração',
    removerPolitica: 'Remover política',
    verLancamentos: 'Ver lançamentos',
    baixarFoto: 'Baixar foto',
  },
  campos: {
    funcionario: 'Funcionário',
    funcionarioAjuda: 'Vazio: o seu próprio ponto.',
    dia: 'Dia',
    hora: 'Hora',
    momento: 'Dia e hora',
    origem: 'Origem',
    situacao: 'Situação',
    foraDeLinha: 'Fora de linha',
    horaAparelho: 'Hora do aparelho',
    recebidaEm: 'Recebida em',
    localizacao: 'Localização',
    precisao: 'Precisão',
    cerca: 'Cerca virtual',
    foto: 'Foto',
    ip: 'IP',
    tipo: 'Tipo',
    justificativa: 'Justificativa',
    justificativaAjuda: 'Diga o que aconteceu: quem aprova lê aqui.',
    estado: 'Situação',
    pedidoPor: 'Pedido por',
    decididoPor: 'Decidido por',
    motivo: 'Motivo',
    mes: 'Mês',
    empresa: 'Empresa',
    esperado: 'Esperado',
    trabalhado: 'Trabalhado',
    extra50: 'Extra 50%',
    extra100: 'Extra 100%',
    debito: 'Atrasos e saídas',
    falta: 'Faltas',
    faltasDias: 'Dias de falta',
    abonados: 'Dias abonados',
    intervalo: 'Intervalo',
    marcacoes: 'Marcações',
    regime: 'Banco de horas',
    saldo: 'Saldo',
    aVencer: 'Vence em 30 dias',
    proximoVencimento: 'Próximo vencimento',
    ateMes: 'Até o mês',
    natureza: 'Lançamento',
    vencimento: 'Vencimento',
    minutos: 'Horas',
    funcionarios: 'Funcionários',
    fechadoPor: 'Fechado por',
    fechadoEm: 'Fechado em',
    reabertoPor: 'Reaberto por',
    folhaHe50: 'Para a folha: extra 50%',
    folhaHe100: 'Para a folha: extra 100%',
    folhaDesconto: 'Para a folha: desconto',
    bancoCredito: 'Crédito no banco',
    bancoDebito: 'Débito no banco',
    bancoVencido: 'Vencido no banco',
    toleranciaMarcacao: 'Tolerância por marcação (min)',
    toleranciaMarcacaoAjuda: 'CLT, art. 58: variações de até 5 minutos por marcação não contam.',
    toleranciaDia: 'Tolerância no dia (min)',
    toleranciaDiaAjuda: 'Limite da soma no dia (10 minutos pela CLT). Passou, conta tudo.',
    contratos: 'Contratos que batem ponto',
    regimePadrao: 'Banco de horas (padrão)',
    exigeLocalizacao: 'Exige localização',
    exigeFoto: 'Exige foto',
    escopo: 'Vale para',
    alvo: 'Empresa, departamento ou funcionário',
    cercaAtiva: 'Cerca virtual',
    latitude: 'Latitude do centro',
    longitude: 'Longitude do centro',
    raio: 'Raio (metros)',
    horario: 'Horário do dia',
    proxima: 'Próxima marcação',
    agora: 'Hora do servidor',
  },
  origem: { app: 'Aplicativo', web: 'Tela', ajuste: 'Ajuste', relogio: 'Relógio', importacao: 'Importação' },
  estado: { pedido: 'Em aberto', aprovado: 'Aprovado', recusado: 'Recusado', cancelado: 'Cancelado', todos: 'Todos' },
  tipoAjuste: { incluir: 'Incluir marcação', desconsiderar: 'Desconsiderar marcação' },
  situacao: { normal: 'Normal', falta: 'Falta', abonado: 'Abonado', descanso: 'Descanso', incompleto: 'Marcação sem par', hoje: 'Hoje', futuro: 'A vir', fora_do_vinculo: 'Fora do vínculo' },
  regime: { nenhum: 'Sem banco (extras na folha)', individual: 'Individual (compensa em 6 meses)', coletivo: 'Coletivo (compensa em 1 ano)' },
  contrato: { clt: 'CLT', pj: 'PJ', estagio: 'Estágio', temporario: 'Temporário' },
  escopo: { empresa: 'Empresa', departamento: 'Departamento', funcionario: 'Funcionário' },
  natureza: { credito: 'Crédito', debito: 'Débito', vencimento: 'Baixa do vencido' },
  fechamento: { fechado: 'Fechado', reaberto: 'Reaberto' },
  proxima: { entrada: 'Entrada', saida: 'Saída' },
  herdar: 'Herda',
  sim: 'Sim',
  nao: 'Não',
  dentro: 'Dentro',
  fora: 'Fora',
  desconsiderada: 'Desconsiderada',
  ajustePendente: 'Ajuste em aberto',
  tolerancia: 'na tolerância',
  intervaloCurto: 'intervalo menor que 1 hora',
  semHorario: 'Sem horário no calendário: vale só a jornada em horas.',
  horarioDoDia: '{{entrada}} às {{saida}}',
  intervaloDoDia: 'intervalo {{inicio}} às {{fim}}',
  nenhumaHoje: 'Nenhuma marcação hoje.',
  trabalhadoHoje: '{{trabalhado}} trabalhadas de {{esperado}}',
  regimeDe: 'Banco de horas: {{regime}}',
  toleranciaDe: 'Tolerância de {{marcacao}} min por marcação e {{dia}} min no dia',
  pendentes_one: '{{count}} ajuste em aberto neste período',
  pendentes_other: '{{count}} ajustes em aberto neste período',
  semAusencias: 'Férias e ausências desligado: nenhum dia é abonado.',
  resultado: 'Resultado do mês',
  vazio: {
    semFuncionario: 'Seu usuário não está ligado a um funcionário em Pessoas. Peça ao RH para cadastrar o seu e-mail no seu cadastro.',
    semPonto: 'Seu vínculo de trabalho não bate ponto (o tipo de contrato não está na configuração do ponto).',
    marcacoes: 'Nenhuma marcação por aqui.',
    ajustes: 'Nenhum ajuste por aqui.',
    banco: 'Nenhum saldo de banco de horas. O saldo nasce no fechamento do mês de quem está no banco.',
    fechamentos: 'Nenhum mês fechado ainda.',
    politicas: 'Nenhuma política própria: vale o padrão do workspace.',
    espelho: 'Escolha um funcionário para ver o espelho.',
    lancamentos: 'Nenhum lançamento.',
  },
  aviso: {
    localizacao: 'Esta marcação pede a sua localização: o navegador vai perguntar.',
    foto: 'Esta marcação pede uma foto.',
    cerca: 'Só vale dentro do local de trabalho.',
    semLocalizacao: 'Não foi possível ler a sua localização. Permita o acesso e tente de novo.',
    fotoGrande: 'A foto passa de 512 KB: escolha uma menor.',
    configTodas: 'A configuração vale para todas as empresas: só quem vê todas as empresas altera.',
    fecharEmpresa: 'Fecha o ponto da empresa escolhida. Depois de fechado, marcações e ajustes do mês não mudam e a folha passa a ler o resultado.',
    escolhaEmpresa: 'Escolha a empresa para fechar o ponto dela.',
    reabrir: 'As marcações e os ajustes do mês voltam a mudar e os lançamentos do banco deste fechamento saem.',
    politica: 'Campo em "Herda" segue o escopo menos específico (funcionário, depois departamento, depois empresa, depois o workspace).',
  },
  recusar: { titulo: 'Recusar o ajuste', ajuda: 'Diga o motivo: a pessoa vê no ajuste.' },
  confirmar: { cancelar: 'Cancelar o ajuste?', cancelarTexto: 'O pedido sai da lista de aprovação.', remover: 'Remover a política?', removerTexto: 'O alvo volta a seguir o escopo menos específico.' },
  marcado: 'Ponto marcado às {{hora}}',
  relogio: i18nRelogio.pt,
  fiscal: i18nFiscal.pt,
};

const en: typeof pt = {
  nome: 'Time clock',
  abas: { marcar: 'Clock in', marcacoes: 'Punches', espelho: 'Timesheet', ajustes: 'Adjustments', banco: 'Hour bank', fechamentos: 'Closings', fiscal: 'Fiscal files', configuracao: 'Settings' },
  indicadores: { ponto_ausentes_sem_justificativa: 'Absent without justification today' },
  acoes: {
    marcarEntrada: 'Clock in',
    marcarSaida: 'Clock out',
    escolherFoto: 'Choose photo',
    trocarFoto: 'Change photo',
    novoAjuste: 'New adjustment',
    pedirDesconsiderar: 'Request to disregard',
    aprovar: 'Approve',
    recusar: 'Decline',
    cancelarAjuste: 'Cancel adjustment',
    fecharMes: 'Close month',
    reabrir: 'Reopen',
    novaPolitica: 'New policy',
    editarConfiguracao: 'Edit settings',
    removerPolitica: 'Remove policy',
    verLancamentos: 'See entries',
    baixarFoto: 'Download photo',
  },
  campos: {
    funcionario: 'Employee',
    funcionarioAjuda: 'Empty: your own time clock.',
    dia: 'Day',
    hora: 'Time',
    momento: 'Day and time',
    origem: 'Source',
    situacao: 'Status',
    foraDeLinha: 'Offline',
    horaAparelho: 'Device time',
    recebidaEm: 'Received at',
    localizacao: 'Location',
    precisao: 'Accuracy',
    cerca: 'Geofence',
    foto: 'Photo',
    ip: 'IP',
    tipo: 'Type',
    justificativa: 'Justification',
    justificativaAjuda: 'Say what happened: the approver reads it here.',
    estado: 'Status',
    pedidoPor: 'Requested by',
    decididoPor: 'Decided by',
    motivo: 'Reason',
    mes: 'Month',
    empresa: 'Company',
    esperado: 'Expected',
    trabalhado: 'Worked',
    extra50: 'Overtime 50%',
    extra100: 'Overtime 100%',
    debito: 'Late arrivals and early departures',
    falta: 'Absences',
    faltasDias: 'Days absent',
    abonados: 'Excused days',
    intervalo: 'Break',
    marcacoes: 'Punches',
    regime: 'Hour bank',
    saldo: 'Balance',
    aVencer: 'Expires in 30 days',
    proximoVencimento: 'Next expiration',
    ateMes: 'Up to month',
    natureza: 'Entry',
    vencimento: 'Expiration',
    minutos: 'Hours',
    funcionarios: 'Employees',
    fechadoPor: 'Closed by',
    fechadoEm: 'Closed at',
    reabertoPor: 'Reopened by',
    folhaHe50: 'To payroll: overtime 50%',
    folhaHe100: 'To payroll: overtime 100%',
    folhaDesconto: 'To payroll: deduction',
    bancoCredito: 'Bank credit',
    bancoDebito: 'Bank debit',
    bancoVencido: 'Expired in the bank',
    toleranciaMarcacao: 'Tolerance per punch (min)',
    toleranciaMarcacaoAjuda: 'Brazilian labor law, art. 58: variations of up to 5 minutes per punch do not count.',
    toleranciaDia: 'Tolerance per day (min)',
    toleranciaDiaAjuda: 'Daily limit of the sum (10 minutes by law). Above it, everything counts.',
    contratos: 'Contracts that clock in',
    regimePadrao: 'Hour bank (default)',
    exigeLocalizacao: 'Requires location',
    exigeFoto: 'Requires photo',
    escopo: 'Applies to',
    alvo: 'Company, department or employee',
    cercaAtiva: 'Geofence',
    latitude: 'Center latitude',
    longitude: 'Center longitude',
    raio: 'Radius (meters)',
    horario: 'Schedule of the day',
    proxima: 'Next punch',
    agora: 'Server time',
  },
  origem: { app: 'App', web: 'Screen', ajuste: 'Adjustment', relogio: 'Time clock device', importacao: 'Import' },
  estado: { pedido: 'Open', aprovado: 'Approved', recusado: 'Declined', cancelado: 'Canceled', todos: 'All' },
  tipoAjuste: { incluir: 'Add punch', desconsiderar: 'Disregard punch' },
  situacao: { normal: 'Normal', falta: 'Absent', abonado: 'Excused', descanso: 'Rest day', incompleto: 'Unpaired punch', hoje: 'Today', futuro: 'Upcoming', fora_do_vinculo: 'Outside employment' },
  regime: { nenhum: 'No bank (overtime to payroll)', individual: 'Individual (offset within 6 months)', coletivo: 'Collective (offset within 1 year)' },
  contrato: { clt: 'CLT employee', pj: 'Contractor', estagio: 'Intern', temporario: 'Temporary' },
  escopo: { empresa: 'Company', departamento: 'Department', funcionario: 'Employee' },
  natureza: { credito: 'Credit', debito: 'Debit', vencimento: 'Expired write-off' },
  fechamento: { fechado: 'Closed', reaberto: 'Reopened' },
  proxima: { entrada: 'In', saida: 'Out' },
  herdar: 'Inherits',
  sim: 'Yes',
  nao: 'No',
  dentro: 'Inside',
  fora: 'Outside',
  desconsiderada: 'Disregarded',
  ajustePendente: 'Open adjustment',
  tolerancia: 'within tolerance',
  intervaloCurto: 'break shorter than 1 hour',
  semHorario: 'No schedule in the calendar: only the hours count.',
  horarioDoDia: '{{entrada}} to {{saida}}',
  intervaloDoDia: 'break {{inicio}} to {{fim}}',
  nenhumaHoje: 'No punches today.',
  trabalhadoHoje: '{{trabalhado}} worked of {{esperado}}',
  regimeDe: 'Hour bank: {{regime}}',
  toleranciaDe: 'Tolerance of {{marcacao}} min per punch and {{dia}} min per day',
  pendentes_one: '{{count}} open adjustment in this period',
  pendentes_other: '{{count}} open adjustments in this period',
  semAusencias: 'Time off is turned off: no day is excused.',
  resultado: 'Result of the month',
  vazio: {
    semFuncionario: 'Your user is not linked to an employee in People. Ask HR to add your e-mail to your record.',
    semPonto: 'Your employment does not use the time clock (the contract type is not in the time clock settings).',
    marcacoes: 'No punches here.',
    ajustes: 'No adjustments here.',
    banco: 'No hour bank balance. The balance starts at the month closing for those in the bank.',
    fechamentos: 'No month closed yet.',
    politicas: 'No own policy: the workspace default applies.',
    espelho: 'Choose an employee to see the timesheet.',
    lancamentos: 'No entries.',
  },
  aviso: {
    localizacao: 'This punch asks for your location: the browser will ask.',
    foto: 'This punch asks for a photo.',
    cerca: 'Only valid inside the workplace.',
    semLocalizacao: 'Your location could not be read. Allow access and try again.',
    fotoGrande: 'The photo is over 512 KB: choose a smaller one.',
    configTodas: 'The settings apply to all companies: only someone who sees all companies changes them.',
    fecharEmpresa: 'Closes the time clock of the chosen company. Once closed, the month punches and adjustments do not change and payroll reads the result.',
    escolhaEmpresa: 'Choose the company to close its time clock.',
    reabrir: 'The month punches and adjustments can change again and the hour bank entries of this closing are removed.',
    politica: 'A field on "Inherits" follows the less specific scope (employee, then department, then company, then the workspace).',
  },
  recusar: { titulo: 'Decline the adjustment', ajuda: 'Say the reason: the person sees it in the adjustment.' },
  confirmar: { cancelar: 'Cancel the adjustment?', cancelarTexto: 'The request leaves the approval list.', remover: 'Remove the policy?', removerTexto: 'The target follows the less specific scope again.' },
  marcado: 'Clocked at {{hora}}',
  relogio: i18nRelogio.en,
  fiscal: i18nFiscal.en,
};

const es: typeof pt = {
  nome: 'Registro de jornada',
  abas: { marcar: 'Registrar jornada', marcacoes: 'Registros', espelho: 'Espejo', ajustes: 'Ajustes', banco: 'Banco de horas', fechamentos: 'Cierres', fiscal: 'Archivos fiscales', configuracao: 'Configuración' },
  indicadores: { ponto_ausentes_sem_justificativa: 'Ausentes sin justificación hoy' },
  acoes: {
    marcarEntrada: 'Registrar entrada',
    marcarSaida: 'Registrar salida',
    escolherFoto: 'Elegir foto',
    trocarFoto: 'Cambiar foto',
    novoAjuste: 'Nuevo ajuste',
    pedirDesconsiderar: 'Solicitar descartar',
    aprovar: 'Aprobar',
    recusar: 'Rechazar',
    cancelarAjuste: 'Cancelar ajuste',
    fecharMes: 'Cerrar mes',
    reabrir: 'Reabrir',
    novaPolitica: 'Nueva política',
    editarConfiguracao: 'Editar configuración',
    removerPolitica: 'Quitar política',
    verLancamentos: 'Ver movimientos',
    baixarFoto: 'Descargar foto',
  },
  campos: {
    funcionario: 'Empleado',
    funcionarioAjuda: 'Vacío: tu propia jornada.',
    dia: 'Día',
    hora: 'Hora',
    momento: 'Día y hora',
    origem: 'Origen',
    situacao: 'Situación',
    foraDeLinha: 'Sin conexión',
    horaAparelho: 'Hora del dispositivo',
    recebidaEm: 'Recibido el',
    localizacao: 'Ubicación',
    precisao: 'Precisión',
    cerca: 'Cerca virtual',
    foto: 'Foto',
    ip: 'IP',
    tipo: 'Tipo',
    justificativa: 'Justificación',
    justificativaAjuda: 'Di qué pasó: quien aprueba lo lee aquí.',
    estado: 'Situación',
    pedidoPor: 'Solicitado por',
    decididoPor: 'Decidido por',
    motivo: 'Motivo',
    mes: 'Mes',
    empresa: 'Empresa',
    esperado: 'Esperado',
    trabalhado: 'Trabajado',
    extra50: 'Extra 50%',
    extra100: 'Extra 100%',
    debito: 'Atrasos y salidas anticipadas',
    falta: 'Faltas',
    faltasDias: 'Días de falta',
    abonados: 'Días justificados',
    intervalo: 'Descanso',
    marcacoes: 'Registros',
    regime: 'Banco de horas',
    saldo: 'Saldo',
    aVencer: 'Vence en 30 días',
    proximoVencimento: 'Próximo vencimiento',
    ateMes: 'Hasta el mes',
    natureza: 'Movimiento',
    vencimento: 'Vencimiento',
    minutos: 'Horas',
    funcionarios: 'Empleados',
    fechadoPor: 'Cerrado por',
    fechadoEm: 'Cerrado el',
    reabertoPor: 'Reabierto por',
    folhaHe50: 'A la nómina: extra 50%',
    folhaHe100: 'A la nómina: extra 100%',
    folhaDesconto: 'A la nómina: descuento',
    bancoCredito: 'Crédito en el banco',
    bancoDebito: 'Débito en el banco',
    bancoVencido: 'Vencido en el banco',
    toleranciaMarcacao: 'Tolerancia por registro (min)',
    toleranciaMarcacaoAjuda: 'Ley laboral brasileña, art. 58: variaciones de hasta 5 minutos por registro no cuentan.',
    toleranciaDia: 'Tolerancia en el día (min)',
    toleranciaDiaAjuda: 'Límite de la suma en el día (10 minutos por ley). Por encima, cuenta todo.',
    contratos: 'Contratos que registran jornada',
    regimePadrao: 'Banco de horas (predeterminado)',
    exigeLocalizacao: 'Exige ubicación',
    exigeFoto: 'Exige foto',
    escopo: 'Vale para',
    alvo: 'Empresa, departamento o empleado',
    cercaAtiva: 'Cerca virtual',
    latitude: 'Latitud del centro',
    longitude: 'Longitud del centro',
    raio: 'Radio (metros)',
    horario: 'Horario del día',
    proxima: 'Próximo registro',
    agora: 'Hora del servidor',
  },
  origem: { app: 'Aplicación', web: 'Pantalla', ajuste: 'Ajuste', relogio: 'Reloj', importacao: 'Importación' },
  estado: { pedido: 'Abierto', aprovado: 'Aprobado', recusado: 'Rechazado', cancelado: 'Cancelado', todos: 'Todos' },
  tipoAjuste: { incluir: 'Incluir registro', desconsiderar: 'Descartar registro' },
  situacao: { normal: 'Normal', falta: 'Falta', abonado: 'Justificado', descanso: 'Descanso', incompleto: 'Registro sin par', hoje: 'Hoy', futuro: 'Por venir', fora_do_vinculo: 'Fuera del vínculo' },
  regime: { nenhum: 'Sin banco (extras a la nómina)', individual: 'Individual (compensa en 6 meses)', coletivo: 'Colectivo (compensa en 1 año)' },
  contrato: { clt: 'CLT', pj: 'Contratista', estagio: 'Pasantía', temporario: 'Temporal' },
  escopo: { empresa: 'Empresa', departamento: 'Departamento', funcionario: 'Empleado' },
  natureza: { credito: 'Crédito', debito: 'Débito', vencimento: 'Baja por vencimiento' },
  fechamento: { fechado: 'Cerrado', reaberto: 'Reabierto' },
  proxima: { entrada: 'Entrada', saida: 'Salida' },
  herdar: 'Hereda',
  sim: 'Sí',
  nao: 'No',
  dentro: 'Dentro',
  fora: 'Fuera',
  desconsiderada: 'Descartado',
  ajustePendente: 'Ajuste abierto',
  tolerancia: 'dentro de la tolerancia',
  intervaloCurto: 'descanso menor que 1 hora',
  semHorario: 'Sin horario en el calendario: solo cuentan las horas.',
  horarioDoDia: '{{entrada}} a {{saida}}',
  intervaloDoDia: 'descanso {{inicio}} a {{fim}}',
  nenhumaHoje: 'Ningún registro hoy.',
  trabalhadoHoje: '{{trabalhado}} trabajadas de {{esperado}}',
  regimeDe: 'Banco de horas: {{regime}}',
  toleranciaDe: 'Tolerancia de {{marcacao}} min por registro y {{dia}} min en el día',
  pendentes_one: '{{count}} ajuste abierto en este período',
  pendentes_other: '{{count}} ajustes abiertos en este período',
  semAusencias: 'Vacaciones y ausencias apagado: ningún día se justifica.',
  resultado: 'Resultado del mes',
  vazio: {
    semFuncionario: 'Tu usuario no está vinculado a un empleado en Personas. Pide a RR. HH. que registre tu correo en tu ficha.',
    semPonto: 'Tu vínculo laboral no registra jornada (el tipo de contrato no está en la configuración de la jornada).',
    marcacoes: 'Ningún registro por aquí.',
    ajustes: 'Ningún ajuste por aquí.',
    banco: 'Ningún saldo de banco de horas. El saldo nace en el cierre del mes de quien está en el banco.',
    fechamentos: 'Ningún mes cerrado todavía.',
    politicas: 'Ninguna política propia: vale la predeterminada del workspace.',
    espelho: 'Elige un empleado para ver el espejo.',
    lancamentos: 'Ningún movimiento.',
  },
  aviso: {
    localizacao: 'Este registro pide tu ubicación: el navegador te preguntará.',
    foto: 'Este registro pide una foto.',
    cerca: 'Solo vale dentro del lugar de trabajo.',
    semLocalizacao: 'No fue posible leer tu ubicación. Permite el acceso e inténtalo de nuevo.',
    fotoGrande: 'La foto pasa de 512 KB: elige una más pequeña.',
    configTodas: 'La configuración vale para todas las empresas: solo quien ve todas las empresas la cambia.',
    fecharEmpresa: 'Cierra la jornada de la empresa elegida. Una vez cerrada, los registros y ajustes del mes no cambian y la nómina pasa a leer el resultado.',
    escolhaEmpresa: 'Elige la empresa para cerrar su jornada.',
    reabrir: 'Los registros y ajustes del mes vuelven a cambiar y los movimientos del banco de este cierre se quitan.',
    politica: 'Un campo en "Hereda" sigue el alcance menos específico (empleado, luego departamento, luego empresa, luego el workspace).',
  },
  recusar: { titulo: 'Rechazar el ajuste', ajuda: 'Di el motivo: la persona lo ve en el ajuste.' },
  confirmar: { cancelar: '¿Cancelar el ajuste?', cancelarTexto: 'La solicitud sale de la lista de aprobación.', remover: '¿Quitar la política?', removerTexto: 'El destino vuelve a seguir el alcance menos específico.' },
  marcado: 'Jornada registrada a las {{hora}}',
  relogio: i18nRelogio.es,
  fiscal: i18nFiscal.es,
};

export const i18n = { pt, en, es };
